import Vue from 'vue'
import VueRouter from 'vue-router'
/*
import {findItemLink} from "@/store";
*/
import responsiveRoute from './responsive-route'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
    },
    {
        path: '/explore',
        name: 'Explore',
        component: responsiveRoute({
            xs: () => import(/* webpackChunkName: "Explore-mobile" */ '../views/Explore-mobile.vue'),
            lg: () => import(/* webpackChunkName: "Explore" */ '../views/Explore.vue')

        })
    },
    {
        path: '/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "About" */ '../views/About.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "Contact" */ '../views/Contact.vue')
    },
    {
        path: '/credits',
        name: 'Credits',
        component: () => import(/* webpackChunkName: "Credits" */ '../views/Credits.vue')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import(/* webpackChunkName: "Privacy" */ '../views/Privacy.vue')
    },

    {
        path: '/explore/blue',
        name: 'Blue',
        component: () => import(/* webpackChunkName: "Blue" */ '../views/Blue.vue')
    },
    {
        path: '/explore/green',
        name: 'Green',
        component: () => import(/* webpackChunkName: "Green" */ '../views/Green.vue')
    },
    {
        path: '/explore/yellow',
        name: 'Yellow',
        component: () => import(/* webpackChunkName: "Yellow" */ '../views/Yellow.vue')
    },
    {
        path: '/explore/violet',
        name: 'Violet',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Violet" */ '../views/Violet.vue')
    },
    {
        path: '/explore/indigo',
        name: 'Indigo',
        component: () => import(/* webpackChunkName: "Indigo" */ '../views/Indigo.vue')
    },
    {
        path: '/explore/turquoise',
        name: 'Turquoise',
        component: () => import(/* webpackChunkName: "Turquoise" */ '../views/Turquoise.vue')
    },
    {
        path: '/explore/red',
        name: 'Red',
        component: () => import(/* webpackChunkName: "Red" */ '../views/Red.vue')
    },
    {
        path: '/explore/orange',
        name: 'Orange',
        component: () => import(/* webpackChunkName: "Orange" */ '../views/Orange.vue')
    },

    {
        path: '/contribute',
        name: 'Plenum',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Plenum" */ '../views/Plenum.vue')
    },
    {
        path: '/artifact/:id',
        name: 'Artifact',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Plenum" */ '../views/Artifact.vue')
    },
]

const router = new VueRouter({
/*    scrollBehavior() {
        document.getElementById("topPage").scrollIntoView()
    },*/
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})



export default router
